import React from 'react';
import PropTypes from 'prop-types';
import {HourMinuteSeg} from "../../utils/dates";

class TimelineGroupItem extends React.Component {

  constructor(props) {
    super(props);
    this.state = {show: false};
  }

  showOrHide() {
    const {show} = this.state;
    this.setState({show: !show});
  }

  render() {
    const {children, date, header, icon} = this.props;
    const {show} = this.state;
    const dateParam = new Date(date);
    const time = dateParam.getTime();
    return (
        <li>
          <i className={"fa " + icon}></i>
          <div className="timeline-item">
            <div className="panel-group">
              <div className="panel panel-default">
                <div className="panel-heading">
                  <h6 className="panel-title">
                    <a style={{cursor: 'pointer'}}
                       onClick={() => this.showOrHide(time)}>
                    <span className="time"><i className="fa fa-clock-o"></i>{" "
                    + HourMinuteSeg(dateParam)}</span>{header}</a></h6>
                </div>
                {show ? <div className="panel">
                      <div className="panel-body">
                        {children}
                      </div>
                    </div>
                    : ''}
              </div>
            </div>
          </div>
        </li>
    );
  };
}

TimelineGroupItem.propTypes = {
  date: PropTypes.string,
  header: PropTypes.node,
  icon: PropTypes.string
};

export default TimelineGroupItem;





// WEBPACK FOOTER //
// ./src/component/Timeline/TimelineGroupItem.js